module.exports = __webpack_public_path__ + "img/google-maps.db9811a6.svg";